import {
  assign, endpoint, options, check, convert,
} from '../../helpers';
import models from './models';

/**
 * Database user authentication service
 *
 * @param {Object} props All parameter object used in the process
 * @param {Object=} props.data All data from the interface
 * @param {function=} props.dispatch Redux dispatcher
 * @param {function=} props.error Failed callback function
 * @param {function=} props.success Successful callback function
 */

export default (props) => {
  const state = assign(props);
  const model = models.request(state.data);

  fetch(endpoint('/database-check'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        state.success(response.Data);
      } else {
        state.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};
